import { RestuxResources } from '../../resources'
import { toUpperSnakeCase } from '../../restux/restux.utilities'

const RESOURCE_PREFIX = `@${toUpperSnakeCase(RestuxResources.quoteLine)}`

export const QuoteLineActionTypes = {
  ADD_QUOTE_LINE: `${RESOURCE_PREFIX}/ADD_QUOTE_LINE`,
}
